/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './procedure-monitors.reducer';

export const ProcedureMonitorsDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const procedureMonitorsEntity = useAppSelector(state => state.procedureMonitors.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="procedureMonitorsDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.procedureMonitors.detail.title">ProcedureMonitors</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.procedureMonitors.id">Id</Translate>
            </span>
          </dt>
          <dd>{procedureMonitorsEntity.id}</dd>
          <dt>
            <span id="type">
              <Translate contentKey="tinyMedicRestApp.procedureMonitors.type">Type</Translate>
            </span>
          </dt>
          <dd>{procedureMonitorsEntity.type}</dd>
          <dt>
            <span id="timeAdministered">
              <Translate contentKey="tinyMedicRestApp.procedureMonitors.timeAdministered">Time Administered</Translate>
            </span>
          </dt>
          <dd>{procedureMonitorsEntity.timeAdministered}</dd>
          <dt>
            <span id="reading">
              <Translate contentKey="tinyMedicRestApp.procedureMonitors.reading">Reading</Translate>
            </span>
          </dt>
          <dd>{procedureMonitorsEntity.reading}</dd>
          <dt>
            <span id="notes">
              <Translate contentKey="tinyMedicRestApp.procedureMonitors.notes">Notes</Translate>
            </span>
          </dt>
          <dd>{procedureMonitorsEntity.notes}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.procedureMonitors.active">Active</Translate>
            </span>
          </dt>
          <dd>{procedureMonitorsEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.procedureMonitors.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{procedureMonitorsEntity.cursor}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.procedureMonitors.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{procedureMonitorsEntity.lastupdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.procedureMonitors.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{procedureMonitorsEntity.microSec}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.procedureMonitors.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{procedureMonitorsEntity.timestampentry}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.procedureMonitors.surgery">Surgery</Translate>
          </dt>
          <dd>{procedureMonitorsEntity.surgery ? procedureMonitorsEntity.surgery.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.procedureMonitors.intraOPChart">Intra OP Chart</Translate>
          </dt>
          <dd>{procedureMonitorsEntity.intraOPChart ? procedureMonitorsEntity.intraOPChart.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/procedure-monitors" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/procedure-monitors/${procedureMonitorsEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default ProcedureMonitorsDetail;
